import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { Result } from '../interfaces/Result'
import { useAuth } from './useAuth'

interface C203DeviceDeleteProps {
  execDeviceDelete: (deviceId: string) => Promise<Result>
  loading: loadStatus
}
// C203 デバイス削除API呼出
export const useC203DeviceDelete = (): C203DeviceDeleteProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execDeviceDelete = async (deviceId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.delete(`${baseUrl}${stage}${apiUrl.devicesPath}${deviceId}`, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceDelete, loading }
}
